import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {Subject} from "rxjs";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class TrainingService {
  updateList = new Subject();

  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getTrainingResults() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/trainings/result');
  }

  @Load()
  addTrainingAnswers(result: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/trainings/result', result);
  }

  @Load()
  saveTraining(result: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/trainings', result);
  }

  @Load()
  inviteToTraining(training: any, inviteText: string) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/trainings/invite', {...training, inviteText: inviteText});
  }

  getAllTrainings() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/trainings');
  }

  getTraining(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/trainings/' + id);
  }

  @Load()
  deleteTraining(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/trainings/' + id);
  }

  @Load()
  uploadFile(entity: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + '/api/trainings/upload', formData)
      ;
  }

  @Load()
  importTraining(entity) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, entity.name);

    return this.http
      .post<any>(this.config.api + '/api/trainings/import', formData)
      ;
  }

  @Load()
  exportAnswers(id, resultId, userIds, fromDate, toDate) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get(this.config.api + '/api/trainings/' + id + `/exportResults?${resultId ? 'resultId=' + resultId : ''}` + (fromDate && fromDate.toISOString ? '&from=' + fromDate.toISOString() : '') + (toDate && toDate.toISOString ? '&to=' + toDate.toISOString() : '') + '&userIds=' + (userIds || []).join(','), {responseType: 'arraybuffer'});
  }
}
